export const AgreementNames = {
  MASTER_CLIENT_AGREEMENT: 'MASTER_CLIENT_AGREEMENT',
}
